module.exports = __webpack_public_path__ + "img/other.94284f10.svg";